import(/* webpackMode: "eager", webpackExports: ["FoodGradeAbout"] */ "/app/components/landing-pages/FoodGradeAbout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FoodGradeCapabilities"] */ "/app/components/landing-pages/FoodGradeCapabilities.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FoodGradeCompliance"] */ "/app/components/landing-pages/FoodGradeCompliance.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FoodGradeFAQ"] */ "/app/components/landing-pages/FoodGradeFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FoodGradeHero"] */ "/app/components/landing-pages/FoodGradeHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Stats"] */ "/app/components/landing-pages/Stats.tsx");
